import FButtonPrevious from 'components/BaseComponents/FButton/FPreviousButton'
import FImage from 'components/BaseComponents/FImage'
import SBox from 'components/opinionless/SBox'
import SText from 'components/opinionless/SText'
import { WIZARD_STEPS_MAPPING } from 'containers/Apply/LongBeachWizard'
import { updatePercentageAndStep } from 'v2/components/XProgressBar/utils'
import { LBButton, LBText } from 'containers/Apply/steps/ApplicationStepLBIntroduction'
import { useTranslation } from 'i18n'
import React from 'react'
import { StepWizardChildProps } from 'react-step-wizard'
import { SStyled, useSTheme } from 'styles/theme'
import { ga4_useTitle } from 'utils/ga4'
import XBanner from 'v2/components/XBanner'
import XText from 'v2/components/XText'
import XColors from 'v2/styles/colors'
import { XTEXT_MARGINS, XTEXT_SIZE, XTEXT_TYPE } from 'v2/styles/constants'
import style from './style.module.scss'

const LBTextHeader = SStyled(SText)`
    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            font-size: 24px;
            line-height: 130%;
        }
    `}
`

interface Props {
    setCurrentStep?: (number) => void
    fontFamily: any
    onNextStep?: any
    onPrevious?: any
    updatePercentage: any
}

export const Container = SStyled(SBox)`
    width: 100%;
    max-width: 600px;
`

const HouseholdIncomeIntroduction: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const theme = useSTheme()
    const { t } = useTranslation(window.LANG_NS)
    ga4_useTitle('Household income')

    const fontFamily = props.fontFamily

    const { percentage, wizardStep, childWizzardStep } = updatePercentageAndStep(
        WIZARD_STEPS_MAPPING.householdInfo,
        WIZARD_STEPS_MAPPING.householdInfo.introduction,
        WIZARD_STEPS_MAPPING
    )
    props.updatePercentage(percentage, wizardStep, childWizzardStep)

    return (
        <Container>
            <SBox as="form" onSubmit={() => props.nextStep()}>
                <FButtonPrevious onClick={props.onPrevious} />
                <LBTextHeader
                    sx={{
                        textAlign: 'left',
                        fontSize: '32px',
                        color: theme.colors.secondaryColor,
                        lineHeight: '120%',
                        fontFamily: fontFamily.header,
                    }}
                >
                    {t('long_beach_household_income_header')}
                </LBTextHeader>
                <LBText
                    sx={{
                        textAlignLast: 'left',
                        whiteSpace: 'pre-line',
                        fontFamily: fontFamily.body,
                        fontWeight: '800',
                        lineHeight: '140%',
                        color: '#202020',
                        fontSize: '16px',
                    }}
                >
                    {t('long_beach_household_income_subheader')}
                </LBText>
                <div className={style.icon__container}>
                    <div className={style.icon__container__home_icon}>
                        <FImage imageUrl={'/lb_household_income_home.svg'} alt="home_icon"></FImage>
                    </div>
                    <div className={style.icon__container__icons}>
                        <div className={style.icon__container__icons__person}>
                            <XText
                                size={XTEXT_SIZE.SMALL}
                                color={XColors.lbBlue}
                                type={XTEXT_TYPE.INPUT}
                                margins={XTEXT_MARGINS.NO_MARGINS}
                            >
                                {'YOU'}
                            </XText>
                            <FImage imageUrl={'/lb_household_income_person.svg'} alt="home_icon"></FImage>
                        </div>

                        <div className={style.icon__container__icons__household_members}>
                            <FImage imageUrl={'/lb_household_income_person_bw.svg'} alt="home_icon"></FImage>
                            <FImage imageUrl={'/lb_household_income_person_bw.svg'} alt="home_icon"></FImage>
                            <FImage imageUrl={'/lb_household_income_person_bw.svg'} alt="home_icon"></FImage>
                        </div>
                    </div>
                </div>
                <LBText
                    sx={{
                        textAlignLast: 'left',
                        whiteSpace: 'pre-line',
                        fontFamily: fontFamily.body,
                        fontWeight: '400',
                        lineHeight: '140%',
                        color: theme.colors.gray400,
                        fontSize: '14px',
                        marginBottom: '24px',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: t('long_beach_household_income_description'),
                    }}
                />
                <LBText
                    sx={{
                        textAlignLast: 'left',
                        whiteSpace: 'pre-line',
                        fontFamily: fontFamily.body,
                        fontWeight: '400',
                        lineHeight: '140%',
                        color: theme.colors.gray400,
                        fontSize: '14px',
                        marginBottom: '24px',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: t('long_beach_household_income_introduction_banner_description'),
                    }}
                />

                <LBButton
                    type={'submit'}
                    id={'continueButton'}
                    title={t('continue')}
                    width={'100%'}
                    mt={7}
                    mb={5}
                    textStyle={{
                        fontWeight: 700,
                        fontSize: '14px',
                        lineHeight: '140%',
                        fontFamily: fontFamily.body,
                        color: theme.colors.white,
                    }}
                >
                    {t('continue')}
                </LBButton>
            </SBox>
        </Container>
    )
}

export default HouseholdIncomeIntroduction
